// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"styles_visuallyHidden__lgtwX"};